import request from './request'

// 用户认证相关API
export const authAPI = {
  // 管理员登录
  adminLogin(data) {
    return request({
      url: '/users/login',
      method: 'post',
      data: {
        username: data.username,
        userpwd: data.password // 密码需要在调用时进行MD5加密
      }
    })
  },

  // 机构用户登录
  orgLogin(data) {
    return request({
      url: '/equ/manage/login',
      method: 'post',
      data: {
        username: data.username,
        userpwd: data.userpwd // 密码需要在调用时进行MD5加密
      }
    })
  },

  // 获取用户信息
  getUserInfo(token) {
    return request({
      url: '/users/getu',
      method: 'post',
      data: {
        token: token
      }
    })
  },

  // 获取机构信息
  getOrgInfo(token) {
    return request({
      url: '/equ/manage/getOrg',
      method: 'post',
      data: {
        token: token
      }
    })
  },

  // 用户登出
  logout() {
    return request({
      url: '/users/loginOut',
      method: 'post',
      // 如果登出接口不存在，不显示错误提示
      validateStatus: function (status) {
        return status < 500 // 只对5xx错误抛出异常
      }
    })
  }
}
